import { __require as requireGetBuiltIn } from './node_modules-core-js-internals-get-built-in.js';
import { __require as requireFunctionUncurryThis } from './node_modules-core-js-internals-function-uncurry-this.js';
import { __require as requireObjectGetOwnPropertyNames } from './node_modules-core-js-internals-object-get-own-property-names.js';
import { __require as requireObjectGetOwnPropertySymbols } from './node_modules-core-js-internals-object-get-own-property-symbols.js';
import { __require as requireAnObject } from './node_modules-core-js-internals-an-object.js';

var ownKeys;
var hasRequiredOwnKeys;

function requireOwnKeys () {
	if (hasRequiredOwnKeys) return ownKeys;
	hasRequiredOwnKeys = 1;
	var getBuiltIn = requireGetBuiltIn();
	var uncurryThis = requireFunctionUncurryThis();
	var getOwnPropertyNamesModule = requireObjectGetOwnPropertyNames();
	var getOwnPropertySymbolsModule = requireObjectGetOwnPropertySymbols();
	var anObject = requireAnObject();

	var concat = uncurryThis([].concat);

	// all object keys, includes non-enumerable and symbols
	ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
	  var keys = getOwnPropertyNamesModule.f(anObject(it));
	  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
	};
	return ownKeys;
}

export { requireOwnKeys as __require };
//# sourceMappingURL=node_modules-core-js-internals-own-keys.js.map
